import { useMemo } from 'react';
import { humanize, useResourceList, type FieldMeta, type FieldType } from '../../engine';

// Small finance-module helpers shared by the detail headers/tabs. The bespoke grids
// (invoice lines, timesheet entries, ledger entries) render sub-collection endpoints that
// are not resources, so they hand the engine DataGrid FieldMeta built here rather than meta
// fetched from /v1/meta.

/** Build a FieldMeta with sensible defaults; grids need this for cell render + inline edit. */
export function field(partial: Partial<FieldMeta> & { name: string; type: FieldType }): FieldMeta {
  return {
    label: humanize(partial.name),
    required: false,
    readOnly: false,
    nullable: true,
    filterable: false,
    sortable: false,
    searchable: false,
    inCreate: true,
    inUpdate: true,
    inList: true,
    inDetail: true,
    ...partial,
  };
}

/** id → display name for a reference resource (technicians, clients), for grids that show ids. */
export function useNameMap(resource: string): Map<string, string> {
  const { rows } = useResourceList<{ id: string; name?: string }>(resource, { sort: 'name' }, { limit: 500 });
  return useMemo(() => new Map(rows.map((r) => [String(r.id), String(r.name ?? '')])), [rows]);
}
